import { fReadableCurrency } from '@autone/utils';
import { Stack, type SxProps } from '@mui/material';

import { Metric } from './PeakViewMetrics';

const PriceTypeList = ({
  priceTypes,
  defaultCurrency,
  priceTypeSx,
}: {
  priceTypes?: { value: number; label: string }[];
  defaultCurrency?: string;
  priceTypeSx?: SxProps;
}) => {
  if (!priceTypes || priceTypes.length === 0) {
    return null;
  }

  return (
    <Stack
      alignItems="center"
      justifyContent="space-around"
      direction="row"
      p={1}
      sx={{
        backgroundColor: 'primary.lighter',
        width: '100%',
        borderRadius: 1,
      }}
    >
      {priceTypes.map(({ value, label }) => (
        <Stack key={label} gap={0.5}>
          <Metric
            sx={{
              fontWeight: 500,
              width: '100%',
              textAlign: 'center',
              ...priceTypeSx,
            }}
          >
            {label}
          </Metric>
          <Metric
            color="text.secondary"
            sx={{ width: '100%', textAlign: 'center', ...priceTypeSx }}
          >
            {fReadableCurrency(value, defaultCurrency)}
          </Metric>
        </Stack>
      ))}
    </Stack>
  );
};

export default PriceTypeList;
